export const LEARNING_STATUS_LABELS = Object.freeze({
    assigned: "Назначен",
    in_progress: "В процессе",
    awaiting_review: "Ожидает проверки",
    completed: "Завершён",
    expired: "Доступ истёк",
    revoked: "Доступ отозван",
    draft: "Черновик",
    passed: "Пройден",
    failed: "Не пройден",
    annulled: "Аннулирован",
});

export const newSubmissionId = () => (
    window.crypto?.randomUUID?.()
    || `submit-${Date.now()}-${Math.random().toString(36).slice(2)}`
);

export const moduleMaterialsComplete = (module, progress) => (
    (module?.materials || []).every(item => item.required === false || Boolean(progress[item.id]))
);

export const moduleIsComplete = (module, answers, progress) => {
    const questionsDone = (module?.questions || []).every(item => (
        item.required === false || (
            ![undefined, null, ""].includes(answers[item.id])
            && (!Array.isArray(answers[item.id]) || answers[item.id].length > 0)
        )
    ));
    return moduleMaterialsComplete(module, progress) && questionsDone;
};

export const toIsoOrNull = value => value ? new Date(value).toISOString() : null;

const csvCell = value => `"${String(value ?? "").replace(/"/g, '""')}"`;

export function learningAssignmentsCsv(assignments) {
    const header = ["Кандидат", "Курс", "Версия", "Статус", "Попытки", "Лучший результат", "Ответственный", "Доступ до"];
    const rows = assignments.map(row => [
        row.candidate_name,
        row.course_title,
        row.course_version,
        LEARNING_STATUS_LABELS[row.status] || row.status,
        row.attempts_used,
        row.best_percentage ?? "",
        row.responsible_name || "",
        new Date(row.access_expires_at).toLocaleString("ru-RU"),
    ]);
    return [header, ...rows].map(row => row.map(csvCell).join(";")).join("\n");
}
